import React from "react";
import { compose } from "recompose";
import { withRouter, Redirect, Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import { theme } from "./assets/css/App";
import { Eligibilite, Page404 } from "./views";
import { dspList } from "./enums";

const App = () => (
  <MuiThemeProvider theme={theme}>
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <Switch>
        <Route
          path="/dsp/:codeReseau"
          render={({ match }) => {
            const { codeReseau } = match.params;
            const dsp = dspList.find(element => element.codeReseau === codeReseau);
            return dsp ? (
              <>
                <Helmet>
                  <meta charSet="utf-8" />
                  <title>La carte interactive de la fibre {dsp.libelle}</title>
                </Helmet>
                <Eligibilite dsp={dsp} />
              </>
            ) : (
              <Redirect to={{ pathname: "/404" }} />
            );
          }}
        />
        <Route path="/404">
          <Page404 />
        </Route>
        <Route path="/*">
          <Redirect to={{ pathname: "/404" }} />
        </Route>
      </Switch>
    </SnackbarProvider>
  </MuiThemeProvider>
);

export default compose(withRouter)(App);
